var chunkMapping = {
	"838": [
		24921,
		55533,
		31477,
		93010,
		78840,
		96213,
		60452,
		52634,
		80344,
		9625,
		20330,
		89565,
		88479,
		26978
	]
};
var idToExternalAndNameMapping = {
	"9625": [
		"default",
		"./mui-icons",
		98747
	],
	"20330": [
		"default",
		"./react",
		98747
	],
	"24921": [
		"default",
		"./axios",
		98747
	],
	"26978": [
		"default",
		"./sandbox",
		98747
	],
	"31477": [
		"default",
		"./fuse-ui/AdapterMoment",
		98747
	],
	"52634": [
		"default",
		"./lodash",
		98747
	],
	"55533": [
		"default",
		"./fuse-ui",
		98747
	],
	"60452": [
		"default",
		"./fuse-ui/ThemeProvider",
		98747
	],
	"78840": [
		"default",
		"./fuse-ui/LocalizationProvider",
		98747
	],
	"80344": [
		"default",
		"./mui-core",
		98747
	],
	"88479": [
		"default",
		"./react-router-dom",
		98747
	],
	"89565": [
		"default",
		"./react-dom/client",
		98747
	],
	"93010": [
		"default",
		"./fuse-ui/Icons",
		98747
	],
	"96213": [
		"default",
		"./fuse-ui/ProofpointLogo",
		98747
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}